module.exports = __webpack_public_path__ + "img/transpiration-excessive.55d5189b.jpg";